<template>
  <div
    class="w-full h-full flex flex-col items-center justify-center p-6 animate-fade-in"
    :class="theme.text"
  >
    <div class="w-full max-w-sm text-center">
      <div class="mb-8 relative inline-block">
        <div
          class="absolute inset-0 bg-amber-500/30 blur-2xl rounded-full"
        ></div>
        <icon-base
          name="Crown"
          class="w-24 h-24 text-amber-500 relative z-10 animate-bounce"
        ></icon-base>
      </div>
      <h2 class="text-3xl font-bold mb-4 animate-shine">
        {{ t.vip_success_title }}
      </h2>
      <p class="opacity-60 mb-10">{{ t.vip_success_desc }}</p>
      <button
        @click="$emit('back')"
        class="w-full py-4 rounded-2xl font-bold text-lg shadow-xl transition-all active:scale-95 flex items-center justify-center"
        :class="theme.accent"
      >
        {{ t.vip_success_btn }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme", "t"],
};
</script>
